(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["formula-toggle"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('formula-toggle')) {

    class FormulaToggle extends HTMLElement {

      connectedCallback() {
        this.syncSelection();

        this.addEventListener('click', this.handleClick);
      }


      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
      }


      handleClick = (event) => {
        const clickedOption = event.target.closest('[data-formula-option]');

        if (!clickedOption) return;

        const formulaToggle = clickedOption.closest('formula-toggle');

        if (!formulaToggle) return;

        formulaToggle.setSelectedOption(clickedOption);
      };


      setSelectedOption(selectedOption) {
        const options = this.querySelectorAll('[data-formula-option]');

        options.forEach((option) => {
          const isSelected = option === selectedOption;

          option.classList.toggle(
            'formula-toggle__option--active',
            isSelected
          );

          if (isSelected) {
            option.setAttribute('aria-current', 'page');
          } else {
            option.removeAttribute('aria-current');
          }
        });
      }


      syncSelection() {
        const options = this.querySelectorAll('[data-formula-option]');

        if (!options.length) return;

        const currentPath = this.normalizePath(window.location.pathname);

        let matchingOption = null;

        options.forEach((option) => {
          const optionUrl = new URL(
            option.href,
            window.location.origin
          );

          const optionPath = this.normalizePath(optionUrl.pathname);

          if (optionPath === currentPath) {
            matchingOption = option;
          }
        });

        if (matchingOption) {
          this.setSelectedOption(matchingOption);
        }
      }


      normalizePath(path) {
        if (!path) return '/';

        return path.length > 1
          ? path.replace(/\/+$/, '')
          : path;
      }

    }


    customElements.define(
      'formula-toggle',
      FormulaToggle
    );

  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-toggle-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('formula-toggle')) {
  class FormulaToggle extends HTMLElement {
    connectedCallback() {
      this.syncSelection();

      this.addEventListener('click', event => {
        const option = event.target.closest('[data-formula-option]');
        if (option) this.setSelectedOption(option);
      });
    }

    setSelectedOption(selected) {
      this.querySelectorAll('[data-formula-option]').forEach(option => {
        const active = option === selected;

        option.classList.toggle(
          'formula-toggle__option--active',
          active
        );

        if (active) {
          option.setAttribute('aria-current', 'page');
        } else {
          option.removeAttribute('aria-current');
        }
      });
    }

    syncSelection() {
      const currentPath = this.normalizePath(
        window.location.pathname
      );

      this.querySelectorAll('[data-formula-option]').forEach(option => {
        const optionPath = this.normalizePath(
          new URL(option.href, window.location.origin).pathname
        );

        if (optionPath === currentPath) {
          this.setSelectedOption(option);
        }
      });
    }

    normalizePath(path) {
      return path && path.length > 1
        ? path.replace(/\/+$/, '')
        : '/';
    }
  }

  customElements.define('formula-toggle', FormulaToggle);
}
  } catch(e) { console.error(e); }
})();

})();
